//it is placed in a separate file from workspacehelper for the work of the splitting code
export type localKeyes = "workspaceToAdd" | "templateToAdd" | "userWorkspaceToAdd" | "taskToAdd";
export type pathPrefix = "workspace" | "template" | "user-workspace" | "task";

/**
 * return uuid from link or sessionStorage (was localStorage, changed to prevent stale data)
 * @param pathName
 * @returns
 */
export const getWokspaceLinkFromPathNameOrLocalStorage = (
	pathName: string,
	pathPrefix: pathPrefix = "workspace",
	_keyToLok: localKeyes = "workspaceToAdd"
) => {
	const uuid = getWorkspaceIdFromPath(pathName, pathPrefix);
	return uuid;
};

export const isLinkContainsWorkspace = (pathName: string) => {
	const uuid =
		getWokspaceLinkFromPathNameOrLocalStorage(pathName, "workspace") ||
		getWokspaceLinkFromPathNameOrLocalStorage(
			pathName,
			"user-workspace",
			"userWorkspaceToAdd"
		) ||
		getWokspaceLinkFromPathNameOrLocalStorage(pathName, "template", "templateToAdd") ||
		getWokspaceLinkFromPathNameOrLocalStorage(pathName, "task", "taskToAdd");
	return !!uuid;
};

export const createTemplateLink = (templateId: number, pathPrefix: pathPrefix = "workspace") => {
	return `${window.location.origin}/${pathPrefix}/${templateId}`;
};

/**
 * get workspaceId from location path
 * @param pathName
 * @returns
 */
export const getWorkspaceIdFromPath = (pathName: string, prefix: pathPrefix = "workspace") => {
	const splited = pathName.split("/");
	if (splited[1] !== prefix || !splited[2]) return null;
	return splited[2];
};
